import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=4aa3adee&"
import script from "./Recipient.vue?vue&type=script&lang=js&"
export * from "./Recipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa3adee')) {
      api.createRecord('4aa3adee', component.options)
    } else {
      api.reload('4aa3adee', component.options)
    }
    module.hot.accept("./Recipient.vue?vue&type=template&id=4aa3adee&", function () {
      api.rerender('4aa3adee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Recipients/Recipient.vue"
export default component.exports